import type { EditableComponent } from '../../../common/model/types.tsx';
import type { State } from '../../reducer.tsx';

export const isInitialising = (state: State, id: string): boolean =>
	state.ui.edit.initialiseInProgress && state.ui.edit.id === id;

export const isEditing = (state: State): boolean =>
	!!state.ui.edit.id && !state.ui.edit.initialiseInProgress;

export const saveIsInProgress = (state: State) => state.ui.edit.saveIsInProgress;

export const getId = (state: State): string => state.ui.edit.id || '';

export const getEditedComponent = (state: State): EditableComponent | undefined =>
	state.ui.edit.editedComponent;

export const getEditedComponentName = (state: State): string =>
	(state.ui.edit.editedComponent && state.ui.edit.editedComponent.name) || '';

export const getNameErrorMessage = (state: State): string | undefined =>
	state.ui.edit.nameErrorMessage;

// TODO getLeadErrorMessage looks unused, can we remove?
export const getLeadErrorMessage = (state: State): string | undefined =>
	state.ui.edit.leadErrorMessage;
